import { createTheme } from '@mui/material/styles';
import { blokkoColors } from './blokkoColors';

const {
  primary,
  primaryDark,
  primaryLight,
  secondary,
  secondaryDark,
  secondaryLight,
} = blokkoColors;

const neutralBackground = '#F9FAFB';

const geistSansStack =
  '"Geist", "Geist Sans", ui-sans-serif, system-ui, sans-serif';

export const blokkoTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: primary,
      light: primaryLight,
      dark: primaryDark,
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: secondary,
      light: secondaryLight,
      dark: secondaryDark,
      contrastText: '#FFFFFF',
    },
    text: {
      primary: '#191c1d',
      secondary: '#494551',
    },
    background: {
      default: neutralBackground,
      paper: '#FFFFFF',
    },
    divider: 'rgba(50, 43, 71, 0.08)',
    success: {
      main: '#2E7D32',
      light: '#E8F5E9',
      dark: '#1B5E20',
      contrastText: '#FFFFFF',
    },
    info: {
      main: primary,
    },
    warning: {
      main: '#FF9800',
    },
    error: {
      main: '#F44336',
    },
    blokko: blokkoColors,
  },
  typography: {
    fontFamily: geistSansStack,
    allVariants: { fontFamily: geistSansStack },
    h1: { fontWeight: 700, letterSpacing: '-0.02em' },
    h2: { fontWeight: 600, letterSpacing: '-0.01em' },
    h3: { fontWeight: 600, letterSpacing: '-0.01em' },
    h4: { fontWeight: 500 },
    h5: { fontWeight: 500 },
    h6: { fontWeight: 500 },
    body1: { fontWeight: 400, lineHeight: 1.6 },
    body2: { fontWeight: 400, lineHeight: 1.5 },
    button: {
      fontWeight: 600,
      textTransform: 'none',
      letterSpacing: '0.01em',
    },
    caption: { fontWeight: 400 },
    overline: { fontWeight: 500, letterSpacing: '0.1em' },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: neutralBackground,
          fontFamily: geistSansStack,
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: 'none',
          fontWeight: 600,
        },
        containedPrimary: {
          backgroundColor: primary,
          '&:hover': {
            backgroundColor: primaryDark,
          },
        },
        containedSecondary: {
          backgroundColor: secondary,
          '&:hover': {
            backgroundColor: secondaryDark,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 2px 8px rgba(50, 43, 71, 0.08)',
        },
      },
    },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          borderRadius: 16,
          backgroundImage: 'none',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: primary,
          borderRadius: 0,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 600,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: geistSansStack,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#FFFFFF',
          borderRight: '1px solid rgba(50, 43, 71, 0.08)',
        },
      },
    },
  },
});

export { blokkoColors };
